import gql from 'graphql-tag';

export const getHouseBuildingPhaseListing = gql`query{
    getHouseBuildingPhaseListing(sortBy: "o_index", sortOrder: "ASC") {
        totalCount
        edges {
            node {
                id
                key
                name
                multipleChoices
                tooltips {
                    ... on object_Tooltip {
                        tooltip
                    }
                }
                disabledByMaterial {
                    ... on object_HouseMaterial {
                        id
                    }
                }
            }
        }
    }
}`;

export const getHouseMaterialListing = gql`query($filter: String!){
    getHouseMaterialListing(filter: $filter) {
        totalCount
        edges {
            node {
                id
                name
                description
                phase
                price {
                    value
                        unit {
                            id
                            abbreviation
                        }
                    toString
                }
                thumbnail
                icon
                vectaryElementId
                buidlingVectaryModel {
                    ... on fieldcollection_BuildingVectaryModel {
                        vectaryId
                        relatedModel {
                            ... on object_HouseMaterial {
                                id
                                name
                            }
                        }
                    }
                }
                materialGroup {
                    ... on object_MaterialGroup {
                        name
                    }
                }
            }
        }
    }
}`;
